import { render, staticRenderFns } from "./MobileApp.vue?vue&type=template&id=b1ffdbac&"
import script from "./MobileApp.vue?vue&type=script&lang=js&"
export * from "./MobileApp.vue?vue&type=script&lang=js&"
import style0 from "./MobileApp.vue?vue&type=style&index=0&id=b1ffdbac&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports